import {
  verifyCodeAPI,
  generateQRCodeAPI,
  completeTwoFactorSetupAPI,
  enableTwoFactorAPI,
  disableTwoFactorAPI,
} from "apis/auth";
import {
  call,
  put,
  takeEvery
} from "redux-saga/effects";
import { getUserProfile, toggleCurrentModal } from "store/actions";
import { showErrorNotification, showSuccessNotification } from "store/notifications/actions";
import {
  generateQRCodeSuccess, verify2FACodeFail, verify2FACodeSuccess, generateQRCodeError
} from "./actions";

import {
  GENERATE_QR_CODE_START, VERIFY_TWO_FACTOR_CODE_START 
} from "./actionTypes";
  
function * generateQRCode(params){
  try {
    const data = yield call(generateQRCodeAPI, params.payload);
    const { status, result } = data;
    if (status)
      yield put(generateQRCodeSuccess(result));
  } catch (error){ 
    yield put(generateQRCodeError(error.message));
    yield put(showErrorNotification(error.message));
  }
}

const callForType = (type, { code, mfaToken, password }) => {
  if (type === "enable") return call(enableTwoFactorAPI, { code });
  if (type === "disable") return call(disableTwoFactorAPI, {
    code,
    password,
  });
  if (type === "setup") return call(completeTwoFactorSetupAPI, {
    mfaToken,
    code,
  });
  return call(verifyCodeAPI, {
    mfaToken,
    code,
  });
};

const SIGN_IN_AGAIN = ["MFA_EXPIRED", "MFA_TOO_MANY_ATTEMPTS", "ACCOUNT_LOCKED"];

function * verifyCode({ payload }) {
  const { history, type, ...params } = payload;
  const signingIn = type === "login" || type === "setup";
  try {
    const data = yield callForType(type, params);
    const { result, status } = data;
    if (signingIn) {
      if (status && result.token) {
        localStorage.setItem("authUser", JSON.stringify(result));
        yield put(getUserProfile());
        yield put(verify2FACodeSuccess(data));
        yield put(toggleCurrentModal(""));
        history.push("/dashboard");
      } 
    } else {
      yield put(verify2FACodeSuccess({ 
        ...data, 
        type,
      }));
      yield put(showSuccessNotification("Verified succcessfully"));
    }
  } catch (error) {
    yield put (verify2FACodeFail(error.message));
    yield put(showErrorNotification(error.message));
    if (signingIn && SIGN_IN_AGAIN.includes(error.type)) {
      yield put(toggleCurrentModal(""));
    }
  }
}

function * twoFactorAuthSaga(){
  yield takeEvery(GENERATE_QR_CODE_START, generateQRCode);
  yield takeEvery(VERIFY_TWO_FACTOR_CODE_START, verifyCode);
}
    
export default twoFactorAuthSaga;